import { IOffer } from '../../../../offer/types';

export function canShowTrap(offers: IOffer[]) {
  return offers.some(({ isResale, offerType, dealType }) => {
    const isSaleFromSuburbanBuilder = dealType === 'sale' && offerType === 'suburban' && !isResale;

    return !isSaleFromSuburbanBuilder;
  });
}
